import { AppState } from '../../types'
import { IframeState } from './model'
import { IframeLoadingState } from '@mulesoft/monitoring-center-components'

const getAll = (state: AppState): IframeState => state.monitoring.iframe;

export const getState = (state: AppState) => getAll(state).state;

export const isLoading = (state: AppState) => getState(state) === IframeLoadingState.LOADING;

export const getSrc = (state: AppState) => getAll(state).src;
